import React, { memo, useCallback, useRef, useState, useEffect } from "react";
import { DatoKeyValuesMap } from "../data/datoContentData";
import { Wrapper, Container } from "../styles/components/section";
import Component from "./component";

const Section = memo(
  ({
    datoContentData,
    handleSetZoomingAnimation,
    cameraRef,
    planesRef,
    sceneRef,
  }) => {
    const sectionRefs = useRef([]);
    const [refsReady, setRefsReady] = useState(false);

    const findComponentByKey = useCallback(key => {
      const section = DatoKeyValuesMap.find(section => section.key === key);
      if (!section) {
        return null;
      }
      return section.component;
    }, []);

    useEffect(() => {
      if (sectionRefs.current.every(ref => ref)) {
        setRefsReady(true);
      }
    }, [datoContentData.length]);

    return (
      <Wrapper className="trident-container">
        {datoContentData?.map((contentItem, index) => {
          const SectionComponent = contentItem.key
            ? findComponentByKey(contentItem.key)
            : contentItem;

          if (!SectionComponent) return null;

          return (
            <Container
              key={contentItem.id || contentItem.key || index}
              className={contentItem.key || contentItem.id}
              ref={el => (sectionRefs.current[index] = el)}
            >
              {refsReady && contentItem.key ? (
                <SectionComponent
                  {...contentItem.content}
                  handleSetZoomingAnimation={handleSetZoomingAnimation}
                  cameraRef={cameraRef}
                  planesRef={planesRef}
                  sceneRef={sceneRef}
                  parentContainerRef={sectionRefs.current[index]}
                />
              ) : (
                <Component {...contentItem} />
              )}
            </Container>
          );
        })}
      </Wrapper>
    );
  }
);

export default Section;
